import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchMpCategories = async (params) => {
  const response = await axiosInstance.get('/mp_categories/', {
    params,
  });
  return response.data;
};

export const useGetMpCategories = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['mp-categories', queryParams],
    queryFn: () => fetchMpCategories(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const mpCategories = data?.results;
  const count = data?.count;
  const next = data?.next;
  const previous = data?.previous;

  return {
    mpCategories,
    count,
    next,
    previous,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
